<template>
  <v-textarea
    outlined
    counter
    rows="6"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <slot />
  </v-textarea>
</template>

<script>
export default {
  name: 'BaseTextarea',
}
</script>
